import axios from 'axios'

export const assignRoles = async (users: number[], roles: number[]) => {
  const response = await axios.post('/users/overview/bulkAssignRoles', {
    data: {
      userIds: users,
      roleIds: roles
    }
  })

  return response
}

export const removeRoles = async (users: number[], roles: number[]) => {
  const response = await axios.delete('/users/overview/bulkRemoveRoles', {
    data: {
      data: {
        userIds: users,
        roleIds: roles
      }
    }
  })

  return response
}
